import { Input, Modal, Spin, Typography } from 'antd'
import { useGoldenPromptAdminQuery } from '../GoldenPrompts/goldenPromptsAdminQueries'

type Props = {
  /** The mutant's golden-prompt id (source_prompt_id), or null when closed. */
  sourcePromptId: string | null
  onClose: () => void
}

const MutantPromptModal = ({ sourcePromptId, onClose }: Props) => {
  const { data: prompt, isLoading } = useGoldenPromptAdminQuery(sourcePromptId)

  return (
    <Modal
      open={sourcePromptId != null}
      onCancel={onClose}
      footer={null}
      title="Mutant prompt"
      width={680}
      destroyOnClose
    >
      {isLoading ? (
        <div style={{ textAlign: 'center', padding: 32 }}>
          <Spin />
        </div>
      ) : prompt ? (
        <Input.TextArea
          value={prompt.prompt_text}
          readOnly
          autoSize={{ minRows: 6, maxRows: 24 }}
          style={{ fontFamily: 'monospace' }}
        />
      ) : (
        <Typography.Text type="secondary">
          This mutant prompt is no longer available.
        </Typography.Text>
      )}
    </Modal>
  )
}

export default MutantPromptModal
